
import React, {Fragment} from "react";
import {LoadingViewState, RouterView} from "../RouterView";
import {Form, FormListener} from "../form/Form";
import {AffiliateProvider, AffiliatesMenuItem, AffiliatesMenuItemType, AffiliatesSettings} from "../../http/protocol";
import {RouteComponentProps, withRouter} from "react-router";
import {AffiliatesService} from "../../services/AffiliatesService";
import {getContainer} from "../../ioc/IOCSetup";
import {FormSubmitError, FormSubmitSuccess} from "../form/FormFeedback";
import {FormGroup} from "../form/FormGroup";
import {FormInput} from "../form/FormInput";
import {Submit} from "../form/Submit";
import { SelectInput } from "../form/SelectInput";


interface Props extends RouteComponentProps {

}

interface State extends LoadingViewState{
    settings?: AffiliatesSettings;
    validationMap? : any;
    menuOrders: AffiliatesMenuItem[]
    order?:AffiliatesMenuItem;
    showAddMenu?:boolean;
    action?:string
}

export class AffiliatesSettingsView extends RouterView<Props,State> implements FormListener<{}> {
    affiliatesService: AffiliatesService;

    constructor(props:Props) {
        super(props);

        this.affiliatesService = getContainer().getAffiliatesService();

        this.state = {validationMap : {}, loading : true, menuOrders:[], order:{}, showAddMenu:false, action:undefined}; 

        this.handleChange = this.handleChange.bind(this);

        this.handleSubmit = this.handleSubmit.bind(this);

        this.handleRemove = this.handleRemove.bind(this);

        this.handleEdit = this.handleEdit.bind(this);

        this.handleSave = this.handleSave.bind(this);   
    }

    loadContent(): Promise<any> | void {
        this.affiliatesService.getSettings().then((res:AffiliatesSettings) => {
            if(res.menu===undefined){
                this.setState({settings:res, menuOrders: []})
            }else{
                this.setState({settings:res, menuOrders: res.menu.items || []})
            }  
        })
    }

    formDidUpdate(formModel:AffiliatesSettings, validationMap : any) {
        this.setState({ settings : formModel, validationMap : validationMap});
    }

    onSubmit():Promise<any> {
        if(!this.state.settings) {
            return Promise.reject("Unable to save settings");
        }
        if(this.state.menuOrders){
            this.state.settings.menu = {items:this.state.menuOrders};
        }
        return this.affiliatesService.saveSettings(this.state.settings).catch(err=>{
            throw new Error("Unable to create/save settings");
        });
    }

    getTitle(): string {
        return "Affiliates Settings";
    }
 
    showAddMenu() {
        this.setState({
            order: undefined,
            showAddMenu:true
        })
    }

    hideAddMenu() {
        this.setState({
            showAddMenu:false
        })
    }

    handleChange(event:any) {
        const order= this.state.order || {};
        order[event.target.name] = event.target.value;
        console.log("receveived event type", event.target.name, event.target.value);
        this.setState({order:order});   
    }
 
    handleSubmit() {
        const menuOrder  = Object.assign([], this.state.menuOrders);
        const order = Object.assign({}, this.state.order);
        if(order.type && order.target && order.url && order.name){
            menuOrder.push(order);
        
            this.setState({
                menuOrders: menuOrder,
                showAddMenu:false
            })
        }     
    }

    handleRemove(event:string){
        const menuOrder:AffiliatesMenuItem[]  = Object.assign([], this.state.menuOrders);

        delete menuOrder[parseInt(event)];
        
        this.setState({
            menuOrders: menuOrder.filter(x => x !== null)
        })        
    }

    handleEdit(key:string){ 
        var data = [...this.state.menuOrders];
        
        this.setState({
            action:key,
            order: data[Number(key)],
            menuOrders: data
        })       
    }

    handleSave(key:string){
    
        var data = [...this.state.menuOrders];
        const order= this.state.order || {};

        if(order.type && order.target && order.url && order.name){
            data[Number(key)] = order;
            this.setState({
                action:"",
                order: undefined,
                menuOrders: data
            })  
        }     
    }


    getSelectType(object:AffiliatesMenuItem, flag:boolean, key: string){
        return (
            <FormGroup className={"form-group"} model="type">
                <select className={"form-control-sm"} name="type" value={object.type}  onChange={this.handleChange} disabled={!flag}>
                    { flag && (<option value="">Choose</option>)}
                    {Object.keys(AffiliatesMenuItemType).map( (value, index) => 
                        <option key={"type-" + key + "-" + index} value={value}>{value}</option>
                    )} 
                </select>
                <br/>
                {(object.type===undefined || object.type.length===0) &&  (
                    <span className={"help-text"}>Type is required</span>  
                )} 
            </FormGroup>
        );
    }


    getSelectTarget(object:AffiliatesMenuItem, flag:boolean, key :string){
        return (
            <FormGroup className={"form-group"} model="target">
                <select className={"form-control-sm"} name="target" value={object.target}  onChange={this.handleChange} disabled={!flag}>
                    { flag && (<option value="">Choose</option>)}
                    {["_blank","_self"].map( (value, index) => 
                        <option key={"target-" + key + "-" + index} value={value}>{value}</option>
                    )} 
                </select>
                <br/>
                {(object.target===undefined || object.target.length===0) &&  (
                    <span className={"help-text"}>Target is required</span>  
                )} 
            </FormGroup>
        );
    }

    getTextUrl(object:AffiliatesMenuItem, flag:boolean){
        return (
            <FormGroup className={"form-group"} model="url">
                <input className={"form-control"} name="url" type="text" value={object.url}  onChange={this.handleChange} readOnly={!flag} />
                {(object.url===undefined || object.url.length===0) &&  (
                    <span className={"help-text"}>Url is required</span>  
                )}                                 
            </FormGroup>
        );
    }


    getTextName(object:AffiliatesMenuItem, flag:boolean){
        return (
            <FormGroup className={"form-group"} model="name">
                <input className={"form-control"} name="name" type="text" value={object.name}  onChange={this.handleChange} readOnly={!flag} />
                {(object.name===undefined || object.name.length===0) &&  (
                    <span className={"help-text"}>Name is required</span>  
                )} 
            </FormGroup>
        );
    }

    getTbody(menuOrder:AffiliatesMenuItem[]){
        const action = this.state.action;
        const order = this.state.order;
        return (
            <Fragment>
                {Object.entries(menuOrder).map(([key, object]) =>(
                    <div key={key} className="row">
                        <div className="col-2">{this.getSelectType(key===action ? order : object, key===action, key)}</div>
                        <div className="col-2">{this.getSelectTarget(key===action ? order : object, key===action, key)}</div>
                        <div className="col-3">{this.getTextUrl( key===action ? order : object, key===action)}</div>
                        <div className="col-3">{this.getTextName( key===action ? order : object, key===action)}</div>
                        {key===action &&(
                            <div className="col-2 actions">
                                <a href="/#" style={{marginRight: '2px'}} className={"btn btn-primary"} onClick={(e:any) => {e.preventDefault(); this.handleSave(key); }}>Save</a>
                                <a href="/#" style={{marginRight: '2px'}} className={"btn btn-secondary"} onClick={(e:any) => { e.preventDefault(); this.handleEdit(""); }}>Cancel</a>
                            </div>
                        )}
                        {key!==action &&(
                            <div className="col-2 actions">                 
                                <a href="/#" style={{marginRight: '2px'}} className={"btn btn-primary"} onClick={(e:any) => { e.preventDefault(); this.handleEdit(key);}}>Edit</a>
                        
                                <a href="/#" style={{marginRight: '2px'}} className={"btn btn-secondary"} onClick={(e:any) => { e.preventDefault(); this.handleRemove(key);}}>Remove</a>
                            </div>
                        )}
                    </div>
                ))}

                {this.state.showAddMenu && (
                    <div className="row"> 
                        <div className="col-2">
                            {this.getSelectType({}, true)}
                        </div>
                        <div className="col-2">
                            {this.getSelectTarget({}, true)}
                        </div>
                        <div className="col-3">
                            {this.getTextUrl({}, true)}
                        </div>
                        <div className="col-3">
                            {this.getTextName({}, true)}
                        </div>
                        <div className="col-2">
                            <a href="/#" className={"btn btn-primary"} onClick={(e:any) => { e.preventDefault(); this.handleSubmit();}}>Save</a>
                            &nbsp;
                            <a href="/#" className={"btn btn-secondary"} onClick={(e:any) => { e.preventDefault(); this.hideAddMenu();}}>Close</a>
                        </div>
                    </div> 
                )}       
            </Fragment>
        );
    }

    getTable(){
        const menuOrder:AffiliatesMenuItem[]  = Object.assign([], this.state.menuOrders);
        return (
            <div className={"card"}>
                <div className="card-body">
                    <label>Affiliate Menu Items</label>
                    <div className="row">
                        <div className="col-2">
                            <span>Type</span>
                        </div>
                        <div className="col-2">
                            <span>Target</span>
                        </div>
                        <div className="col-3">
                            <span>Url</span>
                        </div>
                        <div className="col-3">
                            <span>Name</span>
                        </div>
                        <div className="col-2">
                            <span>Actions</span>
                        </div>
                    </div>
                    {this.getTbody(menuOrder)}
                    <div className="row">
                        <div className="col-2">
                            <span className={"help-block"}> When LINK the screen will send the user to the resource according to the chose value for "target"</span>
                        </div>
                        <div className="col-2">
                            <span className={"help-block"}>When _blank a new tab or window will open, when _self the user will be redirected. (Only value when type = LINK)</span>
                        </div>
                        <div className="col-3">
                            <span className={"help-block"}>The Menu items URL, if it starts with / it will be considered to be an internal link</span>
                        </div>
                        <div className="col-3">
                            <span className={"help-block"}>Unique name for the item</span>
                        </div>
                        <div className="col-2">
                            <span className={"help-block"}></span>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <a href="/#" style={{ float: "left" }} className={"btn btn-primary"} onClick={(e:any) => { e.preventDefault(); this.showAddMenu();}}>Add menu</a>
                        </div>
                    </div>
                </div>
            </div>
                 
        );
    }

    renderContent() {
        if(!this.state.settings) {
            return <span></span>
        }
        return(
            <Fragment>
                <Form className="form-horizontal" formListener={this} modelObject={this.state.settings} validationMap={this.state.validationMap}>
                    <div className={"card"}>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-lg-12">
                                    <FormSubmitError />
                                    <FormSubmitSuccess text="Settings was updated successfully"/>

                                    <FormGroup className="form-group mb-3" model="linkURL">
                                        <label>Link URL</label>
                                        <FormInput className="form-control" model="linkURL" type="text"/>
                                    </FormGroup>
                                    <div className="hr-line-dashed"></div>

                                    <FormGroup className="form-group mb-3" model="logoUrl">
                                        <label>Logo URL</label>
                                        <FormInput className="form-control" model="logoUrl" type="text"/>
                                    </FormGroup>
                                    <div className="hr-line-dashed"></div>

                                    <FormGroup className="form-group mb-3" model="supportEmail">
                                        <label>Support Email</label>
                                        <FormInput className="form-control" model="supportEmail" type="text"/>
                                    </FormGroup>
                                    <div className="hr-line-dashed"></div>

                                    <FormGroup className="form-group mb-3" model="enabledCurrencies">
                                        <label>Enabled Currencies</label>
                                        <FormInput className="form-control" model="enabledCurrencies" type="text"/>
                                        <span className="help-block">Currency codes separated with a single space</span>
                                    </FormGroup>
                                    <div className="hr-line-dashed"></div>

                                    <FormGroup className="form-group mb-3" model="networkCostPercentage">
                                        <label>Network Cost - Fractions</label>
                                        <FormInput className="form-control" model="networkCostPercentage" type="number"/>
                                        <span className="help-block">Example: 0.15 will deduct 15% as network fee</span>
                                    </FormGroup>
                                    <div className="hr-line-dashed"></div>

                                    <FormGroup className="form-group mb-3" model="defaultAffiliateRevenueSharePercentage">
                                        <label>Default Affiliate Revenue Share - Fractions</label>
                                        <FormInput className="form-control" model="defaultAffiliateRevenueSharePercentage" type="number"/>
                                        <span className="help-block">Example: 0.15 will set 15% as default affiliate share</span>
                                    </FormGroup>
                                    <div className="hr-line-dashed"></div>

                                    <FormGroup className="custom-control custom-checkbox" model="enabled">
                                        <FormInput className="custom-control-input"  id={"enabled"} model="enabled" type="checkbox"/>
                                        <label htmlFor={"enabled"} className={"custom-control-label"}>Affiliates Enabled</label>
                                        <span className={"help-block"}></span>
                                    </FormGroup>
                                    <div className="hr-line-dashed"></div>
                                    <FormGroup className="form-group">
                                        <label>Default Provider</label>
                                        <SelectInput id={"defaultProvider"}  model="defaultProvider" optional={true} values={[AffiliateProvider.LOCAL,AffiliateProvider.PARTNER_MATRIX]} className="form-control" required={false}/>
                                        <span className={"help-block"}></span>
                                    </FormGroup>
                                </div>
                            </div>
                        </div>
                    </div>
                     
                    {this.getTable()}
                    
                    <div className={"card"}>
                        <div className={"card-body"}>
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="ibox float-e-margins">
                                        <div className="ibox-content">
                                            <div className="ibox-title">
                                                <h5>Actions</h5>
                                            </div>
                                            <div className="form-group">
                                                <div className="col-sm-10 col-sm-offset-2">
                                                    <Submit className="btn btn-primary waves-effect waves-light">Save Settings</Submit>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Form>
            </Fragment>
        )
    }
}
export default withRouter(AffiliatesSettingsView);